import { useDispatch, useSelector } from "react-redux"
import { changeConfirmEscalation, changeFormActive, changeFormMessage, changeSeverity, changeStatus, changeTicketContents, changeTicketType, changeTitle, clearSupportTicketForm, confirmingEscalation, selectFormMessage, selectFormMode, selectSeverity, selectStatus, selectSupportLevel, selectSupportTicketId, selectTicketContents, selectTicketType, selectTitle } from "./supportTicketFormSlice"

import './SupportTicketForm.css';
import { createSupportTicket, selectSupportTicketComments, updateSupportTicket } from "../supportTickets/supportTicketsSlice";
import { selectUser } from "../home/userSlice";
import { selectToken } from "../login/loginSlice";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import CommentList from "../../components/commentList/CommentList";

export default function SupportTicketForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);
    const userInfo = useSelector(selectUser);
    const username = userInfo.username;
    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;

    const ticketNumber = useSelector(selectSupportTicketId);
    const ticketType = useSelector(selectTicketType);
    const supportLevel = useSelector(selectSupportLevel);
    const ticketTitle = useSelector(selectTitle);
    const ticketContents = useSelector(selectTicketContents);
    const severity = useSelector(selectSeverity);
    const status = useSelector(selectStatus);
    const allTicketComments = useSelector(selectSupportTicketComments);
    const ticketComments = allTicketComments.filter(comment => comment.supportTicketId === ticketNumber);
    const formMode = useSelector(selectFormMode);
    const formMessage = useSelector(selectFormMessage);
    const confirmEscalation = useSelector(confirmingEscalation);

    const handleTicketTypeChange = (event) => {
        dispatch(changeTicketType(event.target.value));
    }

    const handleTicketStatusChange = (event) => {
        dispatch(changeStatus(event.target.value));
    }

    const handleTicketTitleChange = (event) => {
        dispatch(changeTitle(event.target.value));
    }

    const handleTicketContentsChange = event => {
        dispatch(changeTicketContents(event.target.value));
    }

    const handleSeverityChange = event => {
        dispatch(changeSeverity(event.target.value));
    }

    const handleCancelButtonClick = (event) => {
        event.preventDefault();

        dispatch(changeFormActive(false));
        dispatch(clearSupportTicketForm());
    }

    const handleSubmitButtonClick = event => {
        event.preventDefault();
        
        if (!ticketTitle) {
            dispatch(changeFormMessage('Ticket must have a title'));
        } else if (!ticketContents) {
            dispatch(changeFormMessage('Please describe the issue'))
        } else {
            const supportLevel = userRole === 'ADMIN' ? '2' : '1'
            const newSupportTicket = {
                username,
                bankId,
                ticketType,
                supportLevel,
                title: ticketTitle,
                ticketContents,
                severity
            }

            dispatch(createSupportTicket({supportTicket: newSupportTicket, token}))
            dispatch(changeFormActive(false));
            dispatch(clearSupportTicketForm());
        }
    }

    const handleSaveChangesButtonClick = event => {
        event.preventDefault();

        const supportTicket = {
            supportTicketId: ticketNumber,
            ticketType,
            severity,
            status
        }

        dispatch(updateSupportTicket({supportTicket, token}));
        dispatch(changeFormActive(false));
        dispatch(clearSupportTicketForm());
    }
    
    const handleEscalateTicketButtonClick = event => {
        event.preventDefault();

        dispatch(changeConfirmEscalation(true));
    }
    
    const handleEscalationCancel = event => {
        event.preventDefault();

        dispatch(changeConfirmEscalation(false));
    }

    const handleEscalationConfirm = () => {

        dispatch(changeConfirmEscalation(false));
        dispatch(updateSupportTicket({supportTicket: {supportTicketId: ticketNumber, supportLevel: '2'}, token}))
    }

    return (
        <form className="form">
            <h3>{formMode === 'create' ? 'Create New Support Ticket' : 'Support Ticket Details'}</h3>
            {formMessage ? <p className="error">{formMessage}</p> : ""}
            {formMode === 'create' ? "" : <h4>Ticket Number: {ticketNumber}</h4>}
            {formMode === 'create' ?
                <label htmlFor="ticket-title">
                    <h4>Title:</h4>
                    <input onChange={handleTicketTitleChange} value={ticketTitle} ></input>
                </label> :
                <label>Title: {ticketTitle}</label>

            }
            <div className="select-fields">
                <label htmlFor="ticket-severity">
                    Severity:
                    <select onChange={handleSeverityChange} value={severity}>
                        <option value={"1. Blocker"}>1. Blocker</option>
                        <option value={"2. Critical"}>2. Critical</option>
                        <option value={"3. Major"}>3. Major</option>
                        <option value={"4. Minor"}>4. Minor</option>
                        <option value={"5. Trivial"}>5. Trivial</option>
                    </select>
                </label>
                <label htmlFor="ticket-type">
                    Ticket Type:
                    <select onChange={handleTicketTypeChange} value={ticketType}>
                        <option value="Bug">Bug</option>
                        <option value="Enhancement Request">Enhancement Request</option>
                    </select>
                </label>
            </div>
            {formMode === 'create' ? "" : (supportLevel === '2' && userRole === 'SUPERADMIN') || (supportLevel === '1' && (userRole === 'ADMIN' || userRole === 'SUPERADMIN')) ? 
                <label>
                    Status:
                    <select value={status} onChange={handleTicketStatusChange}>
                        <option value={'1. Pending Review'}>1. Pending Review</option>
                        <option value={'2. In Progress'}>2. In Progress</option>
                        <option value={'3. Resolved, Pending Confirmation'}>3. Resolved, Pending Confirmation</option>
                        <option value={'4. Closed'}>4. Closed</option>
                    </select>
                </label> :
                <label>Status: {status}</label>
            }
            <div className="supportTicketDescription">
                <label>
                    <h4>Description:</h4>
                    {formMode === 'create' ? <textarea rows="15" cols="80" onChange={handleTicketContentsChange} value={ticketContents}></textarea> : <p>{ticketContents}</p>}
                </label>
            </div>

            {formMode === 'create' ? "" : 
                <div className="comments">
                    <CommentList comments={ticketComments}/>
                </div>}
            <div className="button-container">
                <button onClick={handleCancelButtonClick}>Cancel</button>
                {supportLevel === '1' ? <button onClick={handleEscalateTicketButtonClick}>Escalate Ticket</button> : ""}
                <button onClick={formMode === 'create' ? handleSubmitButtonClick : handleSaveChangesButtonClick}>{formMode === 'create' ? 'Submit' : 'Save Changes'}</button>
            </div>
            {confirmEscalation ? <ConfirmAction handleCancel={handleEscalationCancel} handleConfirm={handleEscalationConfirm} /> : ""}
        </form>
    )
}